import { render, staticRenderFns } from "./setting-tile.vue?vue&type=template&id=4bce97f5&scoped=true&"
import script from "./setting-tile.vue?vue&type=script&lang=js&"
export * from "./setting-tile.vue?vue&type=script&lang=js&"
import style0 from "./setting-tile.vue?vue&type=style&index=0&id=4bce97f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce97f5",
  null
  
)

export default component.exports